.tracking-icon-wrapper {
  height: 23px;
  width: 23px;
  margin: -2.5px -0 -2.5px -5px;
  display: flex;
  align-content: center;
  align-items: center;

  > .tracking-icon {
    transform: scale(0.45);
  }
}
